import ProductEntity from "@modules/products/entities/ProductEntity";

import { ProductImageSdkDto } from "../types";

export function mapProductImageToSdkDto(
    image: ProductEntity["images"][0]
): ProductImageSdkDto {
    return {
        id: image.id,
        altText: image.altText,
        url: image.url,
    };
}
